import React from 'react';
import { oneOfType, object, array } from 'prop-types';
import { map, get } from 'lodash';
import styled from 'styled-components';
import { FlexContainer, Row, Text, Column, Image, Number, If } from '../../common';
import { WHITE, GREEN_DARK, CULTURED, GRAY_DARK, MAHOGANY, DARK_BLUE, LIGHT_BLUE, ANDROID_GREEN } from '../../../utils/colors';
import { quantityRenderer } from '../../../utils/misc';


const Tag = styled.div`
    display: flex;
    background-color: ${LIGHT_BLUE};
    padding: 8px 15px;
    border-radius: 4px;
`;

const OptimalSubstitutes = ({ itemOriginal, substitutes }) => {
    const renderDiffPrice = (item) => {
        const totalPriceOriginalItem = get(itemOriginal, 'price', 0);
        const totalPriceSubstituteItem = get(item, 'price', 0);
        const diffPrice = Math.abs(totalPriceSubstituteItem - totalPriceOriginalItem);
        const isMore = get(item, 'diffPrice') === 'more';

        if (get(item, 'diffPrice') === 'same') {
            return <Tag>
                <Text size={10} text='Se respetará el precio original' color={DARK_BLUE} strong />
            </Tag>;
        }

        return <Row gap={20} style={{ minWidth: 150 }} justify='space-between'>
            <Text size={10} text='Diferencia precio' strong />
            <Text size={10} text={`${isMore ? '+' : '-'}$${diffPrice}`} color={isMore ? MAHOGANY : ANDROID_GREEN} strong />
        </Row>;
    };

    return (
        <FlexContainer direction='column'>
            <Row>
                <Text text='¡Hola! 👋🏻' />
                <Text text='No encontramos el producto escogido. Selecciona la opción que te interese de los productos que te podemos sugerir.' />
            </Row>
            <Row mT={9.5} mB={4}>
                <Text size={10} semibold text='Original' />
            </Row>
            <Row padding={9} backgroundColor={WHITE} borderRadius={8} fitContent>
                <Column noFlex>
                    <Image src={get(itemOriginal, 'image')} maxHeight={51} maxWidth={51} />
                </Column>
                <Column>
                    <Text size={10} text={get(itemOriginal, 'brandName', 'Sin Marca')} strong nowrap />
                    <Text size={10} text={get(itemOriginal, 'name', 'Producto desconocido')} nowrap />
                    <Row>
                        <Column noFlex>
                            <Text size={10} allowWhiteSpace text={`P. ${quantityRenderer(get(itemOriginal, 'quantity', 1), 'Uni', 'Total')} `} color={GREEN_DARK} />
                        </Column>
                        <Column>
                            <Text size={10} text={<Number isPrice value={get(itemOriginal, 'price', 0)} />} color={GREEN_DARK} strong />
                        </Column>
                    </Row>
                </Column>
            </Row>
            <Row mT={9.5} mB={4}>
                <Text size={10} semibold text='Sustitutos sugeridos' />
            </Row>
            <Row padding={9} backgroundColor={WHITE} borderRadius={8} fitContent>
                <FlexContainer direction='column'>
                    { map(substitutes, item => {
                        return <Row borderTop={`1px solid ${CULTURED}`} padding={9}>
                            <Column mR={10}>
                                <Text text={`${get(item, 'name', 'Producto desconocido')} ${get(item, 'brandName', 'Sin Marca')}`} size={10} strong nowrap />
                                <If condition={get(item, 'quantity', 1) > 1} then={<Text text={`Unidades: ${get(item, 'quantity', 1)}`} size={10} color={GREEN_DARK} strong />} />
                            </Column>
                            <Column align='end'>
                                <Text size={10} text={<Number isPrice value={get(item, 'price', 0)} />} color={GREEN_DARK} strong />
                                {renderDiffPrice(item)}
                            </Column>
                        </Row>;
                    }) }
                    <Row borderTop={`1px solid ${CULTURED}`} padding={9}>
                        <Text size={10} text='No quiero reemplazo' strong />
                    </Row>
                    <Row borderTop={`1px solid ${CULTURED}`} padding={9}>
                        <FlexContainer direction='column' width='100%'>
                            <Text size={10} text='Otro' strong />
                            <FlexContainer padding={8} border={`1px solid ${GRAY_DARK}`} mT={8} borderRadius={6}>
                                <Text size={10} text='Ingresa nombre de producto...' color={GRAY_DARK} />
                            </FlexContainer>
                        </FlexContainer>
                    </Row>
                </FlexContainer>
            </Row>
        </FlexContainer>
    );
};

OptimalSubstitutes.propTypes = {
    itemOriginal: oneOfType([object, array]),
    substitutes: oneOfType([object, array])
};

OptimalSubstitutes.defaultProps = {
    itemOriginal: {},
    substitutes: []
};

export default OptimalSubstitutes;